// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3F-Tx","rootSuccess":"CompleteLink_rootSuccess__1Pp2K","rootFailure":"CompleteLink_rootFailure__iKldO","isDisabled":"CompleteLink_isDisabled__3R5bR"};